export enum TipoEntidade {
  Privado = 0,
  Publico = 1
}

export const TipoEntidadeLabel = new Map<TipoEntidade, string>([
  [TipoEntidade.Privado, "Privado"],
  [TipoEntidade.Publico, "Publico"]
]);
